<template>
  <iframe
    style="border: 0; width: 100%; height: 42px"
    src="https://bandcamp.com/EmbeddedPlayer/track=1298723470/size=small/bgcol=333333/linkcol=ffffff/transparent=true/"
    seamless
  ></iframe>
</template>
